import { render, staticRenderFns } from "./ListUsersBan.vue?vue&type=template&id=642094a0"
import script from "./ListUsersBan.vue?vue&type=script&lang=js"
export * from "./ListUsersBan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports